export default __webpack_public_path__ + "static/media/trenches.178d9da7.png";